import React from 'react';
import Alert from '@mui/material/Alert';
import { useScenario } from 'modules/project/providers/scenario';

const ScenarioPourWarning = () => {
  const { activeScenarioId, activeScenarioName } = useScenario();

  if (!activeScenarioId) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {`You are creating pours in scenario "${activeScenarioName ?? activeScenarioId}". These pours will not appear in master and cannot be merged back.`}
    </Alert>
  );
};

export default ScenarioPourWarning;
